import { Button, Card, Col, DatePicker, Form, Row } from "antd";
import dayjs from "dayjs";
import { cardStyle } from ".";

export default function Filter({ setDate }) {
  return (
    <Card style={cardStyle}>
      <Form layout="vertical">
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item label="Timeline" name="timeline">
              <DatePicker
                placeholder={"Select month"}
                style={{
                  width: "100%",
                }}
                displayFormat="MMM-YYYY"
                picker="month"
                onChange={(_date, dateString) => {
                  if (dateString) {
                    setDate(dateString);
                  } else {
                    setDate(dayjs().format("MMM-YYYY"));
                  }
                }}
                size="middle"
              />
            </Form.Item>
          </Col>

          <Col
            span={24}
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div>
              <Button
                style={{
                  borderRadius: "5px",
                }}
                htmlType="reset"
                onClick={() => {
                  setDate(dayjs().format("MMM-YYYY"));
                }}
              >
                Reset
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}
